import { render, staticRenderFns } from "./GithubRepo.vue?vue&type=template&id=4c91e9e4&scoped=true&"
import script from "./GithubRepo.vue?vue&type=script&lang=js&"
export * from "./GithubRepo.vue?vue&type=script&lang=js&"
import style0 from "./GithubRepo.vue?vue&type=style&index=0&id=4c91e9e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91e9e4",
  null
  
)

export default component.exports